import {
  TTranslation,
} from './item-generic-settings.ts';

import {
  EAppId,
} from '@/types/app-type.ts';
import {
  ESettingsSectionType,
} from '@/types/settings.ts';

const translation: TTranslation = {
  [EAppId.TENANT_SETTINGS]: {
    [ESettingsSectionType.APP_OVERVIEW]: {
      title: 'Przegląd aplikacji',
      subtitle: 'Poniższe ustawienia określają przegląd aplikacji, pasek boczny aplikacji i drzewo uprawnień zarządzania użytkownikami dla wszystkich użytkowników.',
      settingsMap: {
        appGrouping: {
          label: 'Grupowanie aplikacji',
          tooltip: 'Określa, według jakich grup aplikacje są uporządkowane dla wszystkich użytkowników.',
          choices: {
            Department: {
              title: 'Według działu',
              details: 'Przygotowanie produkcji, Produkcja, Zapewnienie jakości, Analityka, Dane podstawowe, Administracja',
            },
            Topic: {
              title: 'Według tematu',
              details: 'Działanie, Proces, Dane/Wgląd, Konserwacja, Konfiguracja',
            },
          },
        },
      },
    },
  },
  [EAppId.REMOTE_CONTROL]: {
    [ESettingsSectionType.REMOTE_CONTROL_PT9800]: {
      title: 'Kontroler PT9800',
      subtitle: 'Poniższe ustawienia określają sposób działania kontrolera PT9800 dla każdego użytkownika.',
      settingsMap: {
        enforceBarcodeScanner: {
          label: 'Wymuszanie skanerów kodów kreskowych.',
          tooltip: 'Jeśli zaznaczono tę opcję, w oknie dialogowym rozpoczynania zadań wymuszane jest potwierdzenie części za pomocą skanera kodów kreskowych.',
        },
      },
    },
  },
};

export default translation;
